import { render, staticRenderFns } from "./Padding.vue?vue&type=template&id=8ac6cbda&"
import script from "./Padding.vue?vue&type=script&lang=js&"
export * from "./Padding.vue?vue&type=script&lang=js&"
import style0 from "./Padding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports